import { IconProps } from "../../utils/global-types/global-types";

const ProgrammingArrowsIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-[12px] h-[12px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9.865 8.05c0-.015.01-.03.01-.05V3.25c0-.76-.615-1.375-1.375-1.375H6.535l.705-.585a.38.38 0 0 0 .05-.53.38.38 0 0 0-.53-.05l-1.5 1.25a.38.38 0 0 0 0 .58l1.5 1.25a.38.38 0 0 0 .53-.05.375.375 0 0 0-.05-.53l-.705-.585H8.5c.345 0 .625.28.625.625V8c0 .02.01.035.01.05A1.498 1.498 0 0 0 9.5 11a1.498 1.498 0 0 0 .365-2.95M6.74 9.46l-1.5-1.25a.375.375 0 0 0-.53.05.375.375 0 0 0 .05.53l.705.585H3.5a.625.625 0 0 1-.625-.625V4c0-.02-.01-.035-.01-.05A1.498 1.498 0 0 0 2.5 1a1.498 1.498 0 0 0-.365 2.95c0 .015-.01.03-.01.05v4.75c0 .76.615 1.375 1.375 1.375h1.965l-.705.585a.38.38 0 0 0-.05.53c.075.09.18.135.29.135a.4.4 0 0 0 .24-.085l1.5-1.25a.38.38 0 0 0 0-.58"
    ></path>
  </svg>
);

export default ProgrammingArrowsIcon;
